import { Badge } from '@octopus-do/octopus-storybook'
import type React from 'react'

export const ReadOnlyBadge: React.FC = () => {
  return <Badge type="read" size="large" />
}
